import { useState, useEffect } from 'react'

import bff from 'services/bff'

import { useNotifications } from 'main/hooks/useNotifications'

import { IOrder, infosData } from './utils/infosData'
import { IDetails, detailsData } from './utils/detailsData'
import { EMessageType } from '@/main/store/notifications'
import { errorHandler } from '@/main/utils/functions/errorHandler'

interface IUseResquestInfos {
  orderId: string
  setLoading: (loading: boolean) => void
  pathname: string
}

export const useRequestInfos = ({ orderId, setLoading, pathname }: IUseResquestInfos) => {
  const { push } = useNotifications()

  const [data, setData] = useState<IOrder>({} as IOrder)
  const [details, setDataDetails] = useState<IDetails[]>([] as IDetails[])

  const type = () => {
    switch (pathname) {
      case '/cartoes/novo/segunda_confirmacao': {
        return 'cards/new/second/confirmation'
      }
      case '/recargas/novo_pedido_importacao/confirmacao':
      case '/recargas/novo_pedido_manual_broker/confirmacao':
      case '/recargas/novo_pedido_manual/confirmacao': {
        return 'recharge/new/confirmation'
      }
    }
  }

  const requestInfo = async () => {
    setLoading(true)
    try {
      const response = await bff.get(`${type()}/${orderId}`)

      setData(infosData({ infos: response?.data }))
      setDataDetails(detailsData({ infos: response?.data, orderId }))
    } catch (error) {
      push(errorHandler({ error: error?.response?.data?.errors }))
    }
    setLoading(false)
  }

  useEffect(() => {
    if (orderId) {
      requestInfo()
    }
    // eslint-disable-next-line
  }, [])

  return {
    details,
    data,
  }
}
